module.exports = __webpack_public_path__ + "static/media/SongSurfer.7b442dce.png";